const StoreType = Object.freeze({
  DESIGN: 'DESIGN',
  COMPARISON: 'COMPARISON',
  HYDRATED: 'HYDRATED',
});

export default StoreType;
